import React, { useState } from 'react';
import { useField } from 'formik';
import { getAsterisk } from '../../components/passwordResetForm';
import { Icon } from '../../../../utilities/icomoon-css';
import ReactTooltip from 'react-tooltip';
import { PasswordToolTip } from '../../PasswordToolTip';
export const MyTextField = ({ label, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label className="content1">
        {label}
        {getAsterisk()}
      </label>
      <input className="cardDetailsInput" {...field} {...props} />
      {meta.touched && meta.error && <ErrorLabel message={meta.error} />}
    </>
  );
};
export const MyPasswordField = ({ label, ...props }: any) => {
  const [passwordShow, setPasswordShow] = useState(false);
  const [field, meta] = useField(props);
  const togglePassword = () => {
    setPasswordShow(!passwordShow);
  };
  return (
    <>
      <div className="passwordToolTipLabel">
        <label className="content1">
          {label}
          {getAsterisk()}
        </label>
        {label === 'Password' ? (
          <>
            <span
              data-tip
              data-for="passwordTip"
              className=" is-flex toolTipSection"
            >
              <Icon name="tfw-danger-circle-cp" size={18}>
                {' '}
              </Icon>
              <ReactTooltip
                className="passwordTipClass"
                id="passwordTip"
                type="light"
                effect="solid"
                backgroundColor="white"
                getContent={PasswordToolTip}
              ></ReactTooltip>
            </span>
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="control has-icons-right">
        <input
          className="is-flex cardDetailsInput"
          type={passwordShow ? 'text' : 'password'}
          {...field}
          {...props}
        />
        <span className="icon is-small is-right">
          <a
            className="is-clickable accountIconPassword"
            type="button"
            onClick={() => togglePassword()}
          >
            {passwordShow ? (
              <Icon name="tfw-show-bold-cp" color="black" size={14} />
            ) : (
              <Icon name="tfw-hide-bold-cp" color="black" size={14} />
            )}
          </a>
        </span>
        {meta.touched && meta.error && <ErrorLabel message={meta.error} />}
      </div>
    </>
  );
};

export const ErrorLabel = ({ message }: { message: string }) => {
  return (
    <>
      {message && (
        <div className="cardFieldsAlertMessage">
          <Icon name="tfw-danger-triangle-cp" size={12} color="red" />
          {message}
        </div>
      )}
    </>
  );
};
